export default "__VITE_ASSET__3KBj3XdI__"